var map = {
	"./CED_red-scene.svg": "2f5e",
	"./CED_yes-scene.svg": "3699",
	"./TED_red-scene.svg": "5101",
	"./TED_yes-scene.svg": "9219",
	"./copy.svg": "d446",
	"./create.svg": "ca23",
	"./info.svg": "7520",
	"./preview-ced.svg": "8834",
	"./preview-ted.svg": "98a2",
	"./publish-survey-ced.svg": "e5db",
	"./publish-survey-ted.svg": "c5ad",
	"./red.svg": "c6a9",
	"./right_sign.svg": "e672",
	"./save-survey-ced.svg": "f5f4",
	"./save-survey-ted.svg": "1a40",
	"./search.svg": "d910",
	"./sright_sign.svg": "c115",
	"./stripes.svg": "24af",
	"./yes.svg": "ecb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d1b0";